import type { TranslationModule } from '../types';

export const ecrisTranslations: TranslationModule = {
  ro: {
    resultsCount: "{count} rezultate",
    filteredResultsCount: "{visible} din {total} dosare",
    sortedByRelevance: "Sortate după relevanță",
    institution: "Instanță",
    allInstitutions: "Toate instanțele",
    matchedParty: "Parte identificată",
    casesFoundFor: "{count} dosare găsite pentru „{query}”",
    filteredCasesStatus: "{visible} din {total} dosare · {institution}",
    match: "potrivire",
    matchPercentage: "{score}% potrivire",
    chooseInstitutionTitle: "Alege instanța",
    chooseInstitutionSubtitle: "Selectează instanța pentru a consulta dosarele identificate.",
    ecrisSearchLoading: "Căutăm dosarele în ECRIS local…",
    ecrisSearchLoadingSub: "Verificăm instanțele în care există dosare corespunzătoare căutării tale.",
    caseCountSingle: "1 dosar",
    caseCountPlural: "{count} dosare",
    backToInstitutions: "Înapoi la instanțe",
    backToSources: "Înapoi la surse",
    noEcrisCasesFound: "Nu am identificat dosare în baza ECRIS locală pentru această căutare.",
    ecrisSearchGeneralError: "Nu am putut finaliza căutarea dosarelor.",
    retry: "Reîncearcă",
    partialResultsNotice: "Căutarea nu a putut verifica toate potrivirile. Lista instanțelor poate fi incompletă.",
    identifiedCases: "{count} dosare identificate",
    identifiedCaseSingle: "1 dosar identificat",
    selectAllCourts: "Selectează toate instanțele",
    allCourtsTitle: "Toate instanțele"
  },
  en: {
    resultsCount: "{count} results",
    filteredResultsCount: "{visible} of {total} cases",
    sortedByRelevance: "Sorted by relevance",
    institution: "Court",
    allInstitutions: "All courts",
    matchedParty: "Matched party",
    casesFoundFor: "{count} cases found for \"{query}\"",
    filteredCasesStatus: "{visible} of {total} cases · {institution}",
    match: "match",
    matchPercentage: "{score}% match",
    chooseInstitutionTitle: "Choose court",
    chooseInstitutionSubtitle: "Select a court to view the identified cases.",
    ecrisSearchLoading: "Searching cases in local ECRIS…",
    ecrisSearchLoadingSub: "Checking courts where cases matching your query exist.",
    caseCountSingle: "1 case",
    caseCountPlural: "{count} cases",
    backToInstitutions: "Back to courts",
    backToSources: "Back to sources",
    noEcrisCasesFound: "No court cases were found in the local ECRIS database for this query.",
    ecrisSearchGeneralError: "Could not complete the case search.",
    retry: "Retry",
    partialResultsNotice: "The search could not verify all matches. The court list may be incomplete.",
    identifiedCases: "{count} cases identified",
    identifiedCaseSingle: "1 case identified",
    selectAllCourts: "Select all courts",
    allCourtsTitle: "All courts"
  },
  fr: {
    resultsCount: "{count} résultats",
    filteredResultsCount: "{visible} sur {total} dossiers",
    sortedByRelevance: "Triés par pertinence",
    institution: "Juridiction",
    allInstitutions: "Toutes les juridictions",
    matchedParty: "Partie identifiée",
    casesFoundFor: "{count} dossiers trouvés pour « {query} »",
    filteredCasesStatus: "{visible} sur {total} dossiers · {institution}",
    match: "correspondance",
    matchPercentage: "{score}% correspondance",
    chooseInstitutionTitle: "Choisir la juridiction",
    chooseInstitutionSubtitle: "Sélectionnez une juridiction pour consulter les dossiers identifiés.",
    ecrisSearchLoading: "Recherche des dossiers dans l'ECRIS local…",
    ecrisSearchLoadingSub: "Vérification des juridictions comportant des dossiers correspondant à votre recherche.",
    caseCountSingle: "1 dossier",
    caseCountPlural: "{count} dossiers",
    backToInstitutions: "Retour aux juridictions",
    backToSources: "Retour aux sources",
    noEcrisCasesFound: "Aucun dossier trouvé dans la base locale ECRIS pour cette recherche.",
    ecrisSearchGeneralError: "Impossible d'effectuer la recherche des dossiers.",
    retry: "Réessayer",
    partialResultsNotice: "La recherche n'a pas pu vérifier toutes les correspondances. La liste des juridictions peut être incomplète.",
    identifiedCases: "{count} dossiers identifiés",
    identifiedCaseSingle: "1 dossier identifié",
    selectAllCourts: "Sélectionner toutes les juridictions",
    allCourtsTitle: "Toutes les juridictions"
  }
};

export default ecrisTranslations;
